import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The Product understanding tab was removed — the attribute worksheet lives in QC checks and catalog
 * Results now — so `/content/attribution` (and anything under it) redirects to Runs.
 */
export const Route = createFileRoute('/_authenticated/_tenant/content/attribution')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/runs' });
  },
});
